import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import { IEDate } from '@appbase/util';
import { openReserveResourceDate } from '@reserve/popup-handler';
import { mapGetters } from 'vuex';
import * as types from '@reserve/store/types'

import WeekItem from './WeekItem.vue';


@Component({
    components: {
        WeekItem
    },

    computed: mapGetters({
        curCompany: types.CALENDAR_COMPANY,
        curCategory: types.CALENDAR_CATEGORY
    })
})
export default class WeekRowItem  extends Vue {
    @Prop({ type: Object }) item!: reserve.DateItem;

    curCompany!: string | null;
    curCategory!: 'FAVORITE' | 'EWS' | 'DB';

    eventsModel: reserve.CalendarItem[] = [];

    @Watch('item')
    itemChanged(newVal: reserve.DateItem) {
        if(newVal.events) {
            this.eventsModel = newVal.events.filter(e => e.id !== 'null');         
        }
    }

    created() {
        if(this.item != null)
            this.itemChanged(this.item);
    }

    onSelectDblClick() {
        if(this.curCompany == null)
            return;

        var target = IEDate(this.item.date);
        openReserveResourceDate(this.curCompany, target, this.curCategory);
    }
}